import React, { useState, useEffect, useContext } from 'react';
import { DropDownComponent, InputComponent, CheckboxComponent, TextAreaComponent, FileUploadComponent } from '../custcomponents';
import DataTable from 'react-data-table-component';
import { toast } from 'react-toastify';
import { AxiosAdminInstance } from '../utils';
import { useNavigate } from 'react-router-dom';
import 'react-loading-skeleton/dist/skeleton.css'
import { validate } from '../validatorutil';
import { Context } from "./authcontext";
// Main Event Component (Handles State)
const AddEvent = () => {
    const [eventStatus, setEventStatus] = useState('DRAFT');
    const [eventTktStatus, setEventTktStatus] = useState('');
    const [eventValidateMembership, setEventValidateMembership] = useState('');
    const [allowBulkBooking, setAllowBulkBooking] = useState('');
    const [eventValidateGender, setEventValidateGender] = useState('');
    const [eventprice, setEventprice] = useState('' as any);
    const [eventInitialprice, setEventInitialprice] = useState('' as any);
    const [discountfrom, setDiscountFrom] = useState('' as any);
    const [discountTo, setDiscountTo] = useState('' as any);
    const [discountPercentage, setDiscountPercentage] = useState('' as any);
    const [endtime, setEndtime] = useState('' as any);
    const [starttime, setStarttime] = useState('' as any);
    const [venuename, setVenuename] = useState('' as any);
    const [eventname, setEventname] = useState('' as any);
    const [eventcode, setEventcode] = useState('' as any);
    const [addressL1, setAddressL1] = useState('' as any);
    const [addressL2, setAddressL2] = useState('' as any);
    const [city, setCity] = useState('' as any);
    const [state, setState] = useState('' as any);
    const [pincode, setPincode] = useState('' as any);
    const [maplink, setMaplink] = useState('' as any);
    const [parking, setParking] = useState(false);
    const [tshirt, setTshirt] = useState(false);
    const [priority, setPriority] = useState('' as any);
    const [loading, setLoading] = useState(false);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [editInProgress, setEditInProgress] = useState(false);
    const [ticketTypeEditInprogress, setTicketTypeEditInprogress] = useState(false);
    const [discountEditInprogress, setDiscountEditInprogress] = useState(null as any);
    const [ticketType, setTicketType] = useState('' as any);
    const [ticketTypeContent, setTicketTypeContent] = useState('' as any);
    const [customdate, setCustomdate] = useState('' as any);
    const [eventTicketTypesList, setEventTicketTypesList] = useState([] as any);
    const [discountTableData, setDiscountTableData] = useState([] as any);
    const [eventListresp, setEventListresp] = useState([] as any);
    const [reloadList, setReloadList] = useState(false);
    let navigate = useNavigate();
    const {user} = useContext(Context);
    
    // Image state variables
    const [backgroundBannerFile, setBackgroundBannerFile] = useState<File | null>(null);
    const [iamAttendingFile, setIamAttendingFile] = useState<File | null>(null);
    const [backgroundBannerUrl, setBackgroundBannerUrl] = useState('');
    const [iamAttendingUrl, setIamAttendingUrl] = useState('');
    const [backgroundBannerContentType, setBackgroundBannerContentType] = useState('');
    const [iamAttendingContentType, setIamAttendingContentType] = useState('');
    
    // Image validation configuration
    const MAX_IMAGE_SIZE = 500 * 1024; // 500KB
    const REQUIRED_WIDTH = 1600;
    const REQUIRED_HEIGHT = 900;

    // Image validation functions
    const validateImageDimensions = (file: File): Promise<boolean> => {
        return new Promise((resolve) => {
            const img = new Image();
            const objectUrl = URL.createObjectURL(file);
            
            img.onload = () => {
                URL.revokeObjectURL(objectUrl);
                const isValid = img.width === REQUIRED_WIDTH && img.height === REQUIRED_HEIGHT;
                if (!isValid) {
                    toast.error(`Image dimensions must be ${REQUIRED_WIDTH}x${REQUIRED_HEIGHT}px. Current: ${img.width}x${img.height}px`);
                }
                resolve(isValid);
            };
            
            img.onerror = () => {
                URL.revokeObjectURL(objectUrl);
                toast.error('Invalid image file');
                resolve(false);
            };
            
            img.src = objectUrl;
        });
    };

    const validateImageSize = (file: File): boolean => {
        if (file.size > MAX_IMAGE_SIZE) {
            toast.error(`Image size must be less than ${MAX_IMAGE_SIZE / 1024}KB. Current: ${(file.size / 1024).toFixed(2)}KB`);
            return false;
        }
        return true;
    };

    const validateImageType = (file: File): boolean => {
        if (!file.type.startsWith('image/')) {
            toast.error('Please select an image file (JPEG, PNG, etc.)');
            return false;
        }
        return true;
    };

    // File upload handlers
    const handleBackgroundBannerChange = async (event: React.ChangeEvent<HTMLInputElement>): Promise<boolean> => {
        const file = event.target.files?.[0];
        if (!file) return false;

        // Validate file type
        if (!validateImageType(file)) return false;

        // Validate file size
        if (!validateImageSize(file)) return false;

        // Validate image dimensions
        const isValidDimensions = await validateImageDimensions(file);
        if (!isValidDimensions) return false;

        setBackgroundBannerFile(file);
        setBackgroundBannerContentType(file.type);
        
        // Create preview URL
        const previewUrl = URL.createObjectURL(file);
        setBackgroundBannerUrl(previewUrl);
        
        return true;
    };

    const handleIamAttendingChange = async (event: React.ChangeEvent<HTMLInputElement>): Promise<boolean> => {
        const file = event.target.files?.[0];
        if (!file) return false;

        // Validate file type
        if (!validateImageType(file)) return false;

        // Validate file size
        if (!validateImageSize(file)) return false;

        // Validate image dimensions
        const isValidDimensions = await validateImageDimensions(file);
        if (!isValidDimensions) return false;

        setIamAttendingFile(file);
        setIamAttendingContentType(file.type);
        
        // Create preview URL
        const previewUrl = URL.createObjectURL(file);
        setIamAttendingUrl(previewUrl);
        
        return true;
    };

    // Convert file to base64
    const fileToBase64 = (file: File): Promise<string> => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                const base64 = reader.result as string;
                // Remove the data:image/jpeg;base64, prefix
                if (base64.includes(',')) {
                    const base64Data = base64.split(',')[1];
                    resolve(base64Data);
                } else {
                    // If no comma found, return the full string (fallback)
                    resolve(base64);
                }
            };
            reader.onerror = error => reject(error);
        });
    };

    useEffect(() => {

        const fetchData = async () => {
            setLoading(true);
            const { data: response } = await AxiosAdminInstance.get('/api/admin/getevent');
            console.log(response);
            if (response.result != "Success" || response.data?.length == 0) {
                setEventListresp([]);
                setLoading(false);
                return;
            }
            setEventListresp(response.data);
            setLoading(false);
        }
        fetchData();
    }, [reloadList]);

    const onTktdelete = (e, tkttypeCliked) => {
        e.preventDefault();
        let data: any = [
            ...eventTicketTypesList
        ]
        let newData: any = [];
        for (let tkttype in data) {
            console.log(data[tkttype]);
            if (data[tkttype].tickettype.toLowerCase() != tkttypeCliked.toLowerCase()) {
                newData.push(data[tkttype]);

            }
        }

        setEventTicketTypesList(newData);

    }
    const onTktedit = (e, tkttypeCliked) => {
        e.preventDefault();

        let data: any = [
            ...eventTicketTypesList
        ]
        let newData: any = [];
        for (let tkttype in data) {
            console.log(data[tkttype]);
            if (data[tkttype].tickettype.toLowerCase() == tkttypeCliked.toLowerCase()) {
                newData.push(data[tkttype]);
                setEventTktStatus(data[tkttype].status);
                setEventValidateMembership(data[tkttype].validatemembership);
                setAllowBulkBooking(data[tkttype].allowbulkbooking);
                setEventValidateGender(data[tkttype].validategender);
                setEventprice(data[tkttype].price);
                setEventInitialprice(data[tkttype].initialprice);
                setTicketType(data[tkttype].tickettype);
                setTicketTypeContent(data[tkttype].content.join('\n'));
                setCustomdate(data[tkttype].customdate || '');
                setTicketTypeEditInprogress(true);
                setDiscountTableData(data[tkttype].discountData);
            }
        }

    }
    const onDiscountCancel = (e) =>{
        e.preventDefault();
        setDiscountEditInprogress(null);
        setDiscountFrom('')
        setDiscountTo('');
        setDiscountPercentage('');
    }
    const onDiscountSaveClick = (e) =>{
        e.preventDefault();
        let newData: any = discountTableData?[
            ...discountTableData
        ]:[]
        
        if(discountEditInprogress)
        {
            for (let tkttype in newData) {
                if (newData[tkttype].from != discountEditInprogress.from && newData[tkttype].to != discountEditInprogress.to && newData[tkttype].discountpercentage != discountEditInprogress.discountpercentage ) {
                    newData.push(newData[tkttype]);
                }
            }
            setDiscountEditInprogress(null);
        }
        newData.push({
            from: discountfrom,
            to: discountTo,
            discountpercentage:discountPercentage
        })
        setDiscountTableData(newData);

    }
    const onDiscountRowEdit = (e, row) => {
        e.preventDefault();

        let data: any = [
            ...discountTableData
        ]
        let newData: any = [];
        for (let tkttype in data) {
            console.log(data[tkttype]);
            if (data[tkttype].from == row.from && data[tkttype].to == row.to && data[tkttype].discountpercentage == row.discountpercentage ) {
                newData.push(data[tkttype]);
                setDiscountFrom(row.from);
                setDiscountTo(row.to);
                setDiscountPercentage(row.discountpercentage);
                setDiscountEditInprogress(row);
            }
        }

    }
    const onDiscountRowdelete = (e, rowdata) => {
        if(e!=null)
        {
        e.preventDefault();
        }
        let data: any = [
            ...discountTableData
        ]
        let newData: any = [];
        for (let tkttype in data) {
            console.log(data[tkttype]);
                if (!(data[tkttype].from == rowdata.from && data[tkttype].to == rowdata.to && data[tkttype].discountpercentage == rowdata.discountpercentage )) {
                    newData.push(data[tkttype]);
                }
            
        }
        
        setDiscountTableData(newData);

    }
  const discountTableColumns= [
    {
        name: 'Action',
        button: true,
        cell: row => (
            <>
                <a href="#" onClick={(e) => { onDiscountRowEdit(e, row) }}>
                    Edit
            </a> /  <a href="#" onClick={(e) => { onDiscountRowdelete(e, row) }}>
                    Delete
            </a>
            </>
        ),
    },
    {
        name: 'From',
        selector: row => row.from,
    },
    {
        name: 'To',
        selector: row => row.to,
    },
    {
        name: 'Discount %',
        selector: row => row.discountpercentage,
    },];

    const columns = [
        { 
            name: 'Action',
            button: true,
            cell: row => (
                <>
                    <a href="#" onClick={(e) => { onTktedit(e, row.tickettype) }}>
                        Edit
                </a> /  <a href="#" onClick={(e) => { onTktdelete(e, row.tickettype) }}>
                        Delete
                </a>
                </>
            ),
        },
        {
            name: 'Ticket Type',
            selector: row => row.tickettype,
        },
        {
            name: 'Price',
            selector: row => row.price,
        },
        {
            name: 'Initial Price',
            selector: row => row.initialprice,
        },
        {
            name: 'Status',
            selector: row => row.status,
        },
        {
            name: 'Validate Membership',
            selector: row => row.validatemembership,
        }, {
            name: 'Validate Gender',
            selector: row => row.validategender,
        }, {
            name: 'Allow Bulk booking',
            selector: row => row.allowbulkbooking,
        },{
            name: 'Content',
            selector: row => row.content,
        },
        {
            name: 'DiscountData',
            selector: row => (
                <div>

                    {

                     row.discountData ?   row.discountData.map((element) => {
                        return   <div> {element.from} - {element.to} = {element.discountpercentage}</div>
                        }):''
                    }
                
                </div>
            ),
        },
        {
            name: 'Priority',
            selector: row => row.priority || 'N/A',
        },

    ];

    const onClickNavigate = (e: any, path: any, eventcode: any) => {
        navigate(`${path}/${eventcode}`);
    }
    const listevtcolumns = [
      
        {
            name: 'Actions',
            button: true,
            width: '80px',
            cell: row => (
                <div className="dropdown">
                    <button 
                        className="btn btn-outline-secondary dropdown-toggle" 
                        type="button" 
                        id={`dropdownMenuButton-${row.eventcode}`}
                        data-toggle="dropdown" 
                        aria-haspopup="true" 
                        aria-expanded="false"
                        style={{ 
                            border: 'none', 
                            background: 'none', 
                            padding: '0',
                            fontSize: '20px',
                            cursor: 'pointer'
                        }}
                    >
                        &#8942;
                    </button>
                    <div 
                        className="dropdown-menu" 
                        aria-labelledby={`dropdownMenuButton-${row.eventcode}`}
                        style={{
                            minWidth: '200px',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                            border: '1px solid #dee2e6'
                        }}
                    >
                        <h6 className="dropdown-header">Event Actions</h6>
                        {user.role == 'ADMIN' && (
                            <>
                                <a 
                                    className="dropdown-item" 
                                    href="#" 
                                    data-scroll-nav="8" 
                                    onClick={(e) => { onEventEdit(e, row) }}
                                    style={{ padding: '8px 16px' }}
                                >
                                    <i className="fa fa-edit mr-2"></i> Edit Event
                                </a>
                                <div className="dropdown-divider"></div>
                            </>
                        )}
                        <a 
                            className="dropdown-item" 
                            href="#" 
                            onClick={(e) => { onClickNavigate(e, '/weba/managespeakers', row.eventcode) }}
                            style={{ padding: '8px 16px' }}
                        >
                            <i className="fa fa-user mr-2"></i> Manage Speakers
                        </a>
                        <a 
                            className="dropdown-item" 
                            href="#" 
                            onClick={(e) => { onClickNavigate(e, '/weba/manageschedule', row.eventcode) }}
                            style={{ padding: '8px 16px' }}
                        >
                            <i className="fa fa-calendar mr-2"></i> Manage Schedule
                        </a>
                        {user.role == 'ADMIN' && (
                            <>
                                <div className="dropdown-divider"></div>
                                         <a 
                                    className="dropdown-item" 
                                    href="#" 
                                    onClick={(e) => { onClickNavigate(e, '/weba/manageawards', row.eventcode) }}
                                    style={{ padding: '8px 16px' }}
                                >
                                    <i className="fa fa-trophy mr-2"></i> Manage Awards
                                </a>
                                           <a 
                                    className="dropdown-item" 
                                    href="#" 
                                    onClick={(e) => { onClickNavigate(e, '/weba/manageawardjury', row.eventcode) }}
                                    style={{ padding: '8px 16px' }}
                                >
                                    <i className="fa fa-trophy mr-2"></i> Manage Award Jury
                                </a>
                                <a 
                                    className="dropdown-item" 
                                    href="#" 
                                    onClick={(e) => { onClickNavigate(e, '/weba/managesponsors', row.eventcode) }}
                                    style={{ padding: '8px 16px' }}
                                >
                                    <i className="fa fa-money mr-2"></i> Manage Sponsors
                                </a>
                                 <a 
                                    className="dropdown-item" 
                                    href="#" 
                                    onClick={(e) => { onClickNavigate(e, '/weba/managepartners', row.eventcode) }}
                                    style={{ padding: '8px 16px' }}
                                >
                                    <i className="fa fa-users mr-2"></i> Manage Partners
                                </a>
                                <a 
                                    className="dropdown-item" 
                                    href="#" 
                                    onClick={(e) => { onClickNavigate(e, '/weba/managecoupons', row.eventcode) }}
                                    style={{ padding: '8px 16px' }}
                                >
                                    <i className="fa fa-star mr-2"></i> Manage Coupons
                                </a>
                                <a 
                                    className="dropdown-item" 
                                    href="#" 
                                    onClick={(e) => { onClickNavigate(e, '/weba/managereports', row.eventcode) }}
                                    style={{ padding: '8px 16px' }}
                                >
                                    <i className="fa fa-bar-chart-o mr-2"></i> View Reports
                                </a>
                                <a 
                                    className="dropdown-item" 
                                    href="#" 
                                    onClick={(e) => { onClickNavigate(e, '/weba/managepages', row.eventcode) }}
                                    style={{ padding: '8px 16px' }}
                                >
                                    <i className="fa fa-file-text mr-2"></i> Manage Pages
                                </a>
                            </>
                        )}
                    </div>
                </div>
            ),
        },
        {
            name: 'Name',
            selector: row => row.name,
            sortable: true,
            allowOverflow: true,
            wrap: true,
            cell: row => (
                <div style={{ wordWrap: 'break-word', whiteSpace: 'normal', maxWidth: '200px' }}>
                    {row.name}
                </div>
            )
        }, {
            name: 'Event Code',
            selector: row => row.eventcode,
            sortable: true,
            wrap: true,
        },
        {
            name: 'Status',
            selector: row => row.status,
            sortable: true,
            wrap: true,
        },
        {
            name: 'Start Date',
            selector: row => row.startdate,
            sortable: true,
            wrap: true,
        }, {
            name: 'End Date',
            selector: row => row.enddate,
            sortable: true,
            wrap: true,
        }, {
            name: 'Venue',
            selector: row => row.venuename,
            wrap: true,
            cell: row => (
                <div style={{ wordWrap: 'break-word', whiteSpace: 'normal', maxWidth: '150px' }}>
                    {row.venuename}
                </div>
            )
        },
        /* {
             cell: row => <CustomMaterialMenu size="small" row={row} />,
             allowOverflow: true,
             button: true,
             width: '56px',
         },*/

    ];

    /* const  CustomMaterialMenu =({size,row}:any)=>
     {
 return(<div className="dropdown">
  <a href="#"  id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
 <i  className="fa fa-solid fa-align-justify"></i></a>
 <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
   <a className="dropdown-item" href="#" data-scroll-nav="8" onClick={(e) => { onEventEdit(e, row) }}>Edit Event</a>
   <a className="dropdown-item" href="#" onClick={(e) => { onClickNavigate(e, '/admin/managespeakers', row.eventcode) }}>Manage Speakers</a>
   <a className="dropdown-item" href="#" onClick={(e) => { onClickNavigate(e, '/admin/manageschedule', row.eventcode) }}>Manage Schedule</a>
   <div className="dropdown-divider"></div>
   <a className="dropdown-item" href="#" onClick={(e) => { onClickNavigate(e, '/admin/managesponsors', row.eventcode) }}>Manage Sponsors</a>
   <a className="dropdown-item" href="#"  onClick={(e) => { onClickNavigate(e, '/admin/managecoupons', row.eventcode) }}>Manage Coupons</a>
 </div>
 </div>);
     }*/
    const onEventEdit = async (e: any, eventobj: any) => {
        e.preventDefault();
        setEventStatus(eventobj.status);
        setEndtime(eventobj.enddate);
        setStarttime(eventobj.startdate);
        setVenuename(eventobj.venuename);
        setEventcode(eventobj.eventcode);
        setEventname(eventobj.name);
        setParking(eventobj.additionalFields?.parking?.enabled);
        setTshirt(eventobj.additionalFields?.tshirt?.enabled);
        setAddressL1(eventobj.addressline1);
        setAddressL2(eventobj.addressline2);
        setCity(eventobj.city);
        setState(eventobj.state);
        setPincode(eventobj.pincode);
        setMaplink(eventobj.maplink);
        
        // Handle existing image URLs - create proper preview URLs
        // Clear all image state first
        setBackgroundBannerFile(null);
        setBackgroundBannerUrl('');
        setBackgroundBannerContentType('');
        setIamAttendingFile(null);
        setIamAttendingUrl('');
        setIamAttendingContentType('');
        
        // Set image URLs only if they exist in the event object
        if (eventobj.backgroundBanner?.imageUrl) {
            setBackgroundBannerUrl(eventobj.backgroundBanner.imageUrl);
        }
        if (eventobj.iamAttending?.imageUrl) {
            setIamAttendingUrl(eventobj.iamAttending.imageUrl);
        }
        
        let data: any = [
        ]
        if(eventobj.tickettypes)
        {
            let keys = Object.keys(eventobj.tickettypes);
            for (let key in keys) {
                data.push({
            tickettype: keys[key],
            price: eventobj.tickettypes[keys[key]].price,
            initialprice: eventobj.tickettypes[keys[key]].initialprice,
            validatemembership: eventobj.tickettypes[keys[key]].validatemembership,
            validategender: eventobj.tickettypes[keys[key]].validategender,
            allowbulkbooking: eventobj.tickettypes[keys[key]].allowbulkbooking,
            status: eventobj.tickettypes[keys[key]].status,
            content: eventobj.tickettypes[keys[key]].content,
            discountData: eventobj.tickettypes[keys[key]].discountData,
            priority: eventobj.tickettypes[keys[key]].priority || null,
            customdate: eventobj.tickettypes[keys[key]].customdate || '',
                });
            }
            setEventTicketTypesList(data);
        }
        setEditInProgress(true);
    }

    const onClickResetEvent = (e: any) => {
        if (e) {
            e.preventDefault();
        }
        setEventTicketTypesList([]);
        setEventTktStatus('Ticket Status');
        setEventValidateMembership('');
        setAllowBulkBooking('');
        setEventValidateGender('');
        setEventprice('');
        setEventInitialprice('');
        setTicketType('');
        setTicketTypeContent('');
        setCustomdate('');
        setPriority('');
        setEventStatus('');
        setEndtime('');
        setStarttime('');
        setVenuename('');
        setEventcode('');
        setEventname('');
        setAddressL1('');
        setAddressL2('');
        setCity('');
        setState('');
        setPincode('');
        setMaplink('');
        setParking(false);
        setTshirt(false);
        setEditInProgress(false);
        setDiscountTableData([]);
        
        // Clear image state completely
        setBackgroundBannerFile(null);
        setIamAttendingFile(null);
        setBackgroundBannerUrl('');
        setIamAttendingUrl('');
        setBackgroundBannerContentType('');
        setIamAttendingContentType('');
        
        // Clear file input elements to ensure they show as empty
        // Instead of replacing elements, just clear the value
        const backgroundBannerInput = document.getElementById('fileBackgroundBanner') as HTMLInputElement;
        const iamAttendingInput = document.getElementById('fileIamAttending') as HTMLInputElement;
        
        if (backgroundBannerInput) {
            backgroundBannerInput.value = '';
        }
        
        if (iamAttendingInput) {
            iamAttendingInput.value = '';
        }
    }
    const onClickAddEvent = async (e: any) => {
        e.preventDefault();
        if (!validate('Event Name', eventname, 'namewithspecial', false, 'txtevtname') || !validate('Event Code', eventcode, 'eventcode', false, 'txtevtcode') ||
            !validate('Venue Name', venuename, 'venuename', false, 'txtevtlocation') ||
            !validate('startdate', starttime, 'date', false, "txtstartDate") ||
            !validate('enddate', endtime, 'date', false, "txtendDate") ||
            !validate('Event Status', eventStatus, 'eventstatus', false, "txtEventstatus") ||
            !validate('Address Line 1', addressL1, 'address', false, "txtAddressL1") ||
            !validate('Address Line 2', addressL2, 'address', false, "txtAddressL2") ||
            !validate('City', city, 'name', false, "txtevtCity") ||
            !validate('State', state, 'name', false, "txtevtState") ||
            !validate('Pincode', pincode, 'pincode', false, "txtevtPincode") ||
            !validate('Maplink', maplink, 'maplink', false, "txtevtmaplink")) {

            return;
        }

        setSubmitLoading(true);
        let evtObj: any = {
            additionalFields: {
                parking: { enabled: parking },
                tshirt: { enabled: tshirt },
            },
            enddate: endtime,
            eventcode: eventcode,
            venuename: venuename,
            name: eventname,
            startdate: starttime,
            status: eventStatus,
            tickettypes: {},
            addressline1: addressL1,
            addressline2: addressL2,
            city: city,
            state: state,
            pincode: pincode,
            maplink: maplink
        }

        for (let evttickettype in eventTicketTypesList) {
            evtObj.tickettypes[eventTicketTypesList[evttickettype].tickettype] = {
                content: eventTicketTypesList[evttickettype].content,
                price: eventTicketTypesList[evttickettype].price,
                initialprice: eventTicketTypesList[evttickettype].initialprice,
                status: eventTicketTypesList[evttickettype].status,
                validatemembership: eventTicketTypesList[evttickettype].validatemembership,
                validategender: eventTicketTypesList[evttickettype].validategender,
                allowbulkbooking: eventTicketTypesList[evttickettype].allowbulkbooking,
                discountData:eventTicketTypesList[evttickettype].discountData,
                priority: eventTicketTypesList[evttickettype].priority || null,
                customdate: eventTicketTypesList[evttickettype].customdate || ''
            }
        }

        // Handle image uploads
        if (backgroundBannerFile) {
            try {
                const backgroundBannerBase64 = await fileToBase64(backgroundBannerFile);
                evtObj.backgroundBanner = {
                    imageBase64: backgroundBannerBase64,
                    imageFileName: backgroundBannerFile.name,
                    contentType: backgroundBannerContentType
                };
            } catch (error) {
                toast.error('Failed to process background banner image');
                setSubmitLoading(false);
                return;
            }
        }

        if (iamAttendingFile) {
            try {
                const iamAttendingBase64 = await fileToBase64(iamAttendingFile);
                evtObj.iamAttending = {
                    imageBase64: iamAttendingBase64,
                    imageFileName: iamAttendingFile.name,
                    contentType: iamAttendingContentType
                };
            } catch (error) {
                toast.error('Failed to process I Am Attending image');
                setSubmitLoading(false);
                return;
            }
        }

        if (editInProgress) {
            try {
                const { data: response, status: statuscode, } = await AxiosAdminInstance.put('/api/admin/createevent', evtObj);
                if (response.result == "Success") {
                    toast("Success.");
                    onClickResetEvent(null);
                    setReloadList(!reloadList);
                    setSubmitLoading(false);
                }
                else {
                    toast.error(response.msg);
                    setSubmitLoading(false);
                }
            } catch (error: any) {
                console.log(error.status);
                setSubmitLoading(false);
            }
        }
        else {
            try {
                const { data: response, status: statuscode, } = await AxiosAdminInstance.post('/api/admin/createevent', evtObj);
                if (response.result == "Success") {
                    toast("Success.");
                    setReloadList(true);
                    setSubmitLoading(false);
                }
                else {
                    toast.error(response.msg);
                    setSubmitLoading(false);
                }
            } catch (error: any) {
                console.log(error.status);
                setSubmitLoading(false);
            }
        }
    }
    const onCancelNewTicketType = (e: any) => {
        e.preventDefault();
        setEventTktStatus('Ticket Status');
        setEventValidateMembership('Validate Membership');
        setAllowBulkBooking('AllowBulkBooking');
        setEventValidateGender('Validate Gender');
        setEventprice('');
        setEventInitialprice('');
        setTicketType('');
        setTicketTypeContent('');
        setCustomdate('');
        setTicketTypeEditInprogress(false);
    }
    const onNewTicketClick = (e: any) => {

        e.preventDefault();

        console.log("check validations")
        if (!validate('Ticket Type', ticketType, 'tickettype', false, "txtevttkttype") || !validate('Price', eventprice, 'price', false, "txtevttktprice") || !validate('Initial Price', eventInitialprice, 'price', false, "txtevttktInitialprice") 
        || !validate('Membership Validation', eventValidateMembership, 'yesno', false, "txtEventValidateMembership") 
        || !validate('AllowBulkBooking', allowBulkBooking, 'yesno', false, "txtAllowBulkBooking") 
        || !validate('Validate Gender', eventValidateGender, 'genderall', false, "txtEventValidateGender") 
        ||
            !validate('Ticket Type Status', eventTktStatus, 'tickettypestatus', false, "txtEventTktstatus")) {
            return;
        }
        let data: any = [
            ...eventTicketTypesList
        ]
        for (let tkttype in data) {
            console.log(data[tkttype]);
            if (data[tkttype] && data[tkttype].tickettype.toLowerCase() == ticketType.toLowerCase()) {
                if (ticketTypeEditInprogress) {
                    data.splice(tkttype, 1)
                }
                else {
                    toast.error("Ticket Type Already Exists.");
                    return;
                }
            }
        }
        data.push({
            tickettype: ticketType,
            price: eventprice,
            initialprice: eventInitialprice,
            validatemembership: eventValidateMembership,
            allowbulkbooking: allowBulkBooking,
            validategender: eventValidateGender,
            status: eventTktStatus,
            content: ticketTypeContent.split('\n'),
            discountData:discountTableData,
            priority: priority || null,
            customdate: customdate
        });


        setEventTicketTypesList(data);
        setEventTktStatus('');
        setEventValidateMembership('');
        setAllowBulkBooking('');
        setEventValidateGender('');
        setEventprice('');
        setEventInitialprice('');
        setTicketType('');
        setTicketTypeContent('');
        setTicketTypeEditInprogress(false);

    }
    return (
        <>
            <section className="register-sec sec-padding-admin">
                <div className="container">
                    <div className="sec-title">
                        <span className="icon-inner wow flipInY" data-wow-duration="300ms"><span className="fa-stack"><i className="fa rhex fa-stack-2x"></i><i className="fa fa-microphone fa-stack-1x"></i></span></span>
                        <h3 className="wow fadeInRight" data-wow-duration="500ms">LIST Events</h3>
                    </div> {/* <!--sec-title end--> */}
                    <div className="register-sec-details">

                        <form>
                            <div className="row pt-2">
                                <div className="col-lg-12 col-md-12 col-sm-12">
                                    <DataTable
                                        columns={listevtcolumns}
                                        data={eventListresp}
                                        progressPending={loading}
                                    />
                                </div>
                            </div>
                        </form>


                    </div> {/* <!--register-sec-details end--> */}
                </div>
            </section>
             {user.role == 'ADMIN'&&  <section className="register-sec  pb-3" data-scroll-index="8">
                <div className="container">
                    <div className="sec-title">
                        <span className="icon-inner wow flipInY" data-wow-duration="300ms"><span className="fa-stack"><i className="fa rhex fa-stack-2x"></i><i className="fa fa-microphone fa-stack-1x"></i></span></span>
                        <h3 className="wow fadeInRight" data-wow-duration="500ms">Add/Edit Event</h3>
                    </div> {/* <!--sec-title end--> */}
                    <div className="register-sec-details">


                        <form>
                            <fieldset className="form-group p-3">
                                <legend className="w-auto px-2 subheading">Event Details</legend>
                                <div className="row pt-2">
                                    <div className="col-lg-6 col-md-6 col-sm-6">

                                        <InputComponent custname="eventName" custid="txtevtname" custplaceholder="Event Name" onExternalValue={setEventname} onExternalBind={eventname} />
                                        <InputComponent custname="EventCode" custid="txtevtcode" custplaceholder="Event Code" onExternalValue={setEventcode} onExternalBind={eventcode} />

                                        <InputComponent custname="EventLocation" custid="txtevtlocation" custplaceholder="Venue Name" onExternalValue={setVenuename} onExternalBind={venuename} />
                                        <InputComponent custname="AddressL1" custid="txtAddressL1" custplaceholder="Addressline 1" onExternalValue={setAddressL1} onExternalBind={addressL1} />
                                        <InputComponent custname="AddressL2" custid="txtAddressL2" custplaceholder="Addressline 2" onExternalValue={setAddressL2} onExternalBind={addressL2} />
                                        <InputComponent custname="EventCity" custid="txtevtCity" custplaceholder="City" onExternalValue={setCity} onExternalBind={city} />


                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-6">
                                        <InputComponent custname="EventState" custid="txtevtState" custplaceholder="State" onExternalValue={setState} onExternalBind={state} />
                                        <InputComponent custname="EventPincode" custid="txtevtPincode" custplaceholder="Pincode" onExternalValue={setPincode} onExternalBind={pincode} />
                                        <InputComponent custname="EventLMaplink" custid="txtevtmaplink" custplaceholder="GoogleMap Link" onExternalValue={setMaplink} onExternalBind={maplink} />

                                        <InputComponent custname="EventStartDate" custid="txtstartDate" custplaceholder="StartDate DD-MMM-YYYY" onExternalValue={setStarttime} onExternalBind={starttime} />
                                        <InputComponent custname="EventEndDate" custid="txtendDate" custplaceholder="EndDate DD-MMM-YYYY" onExternalValue={setEndtime} onExternalBind={endtime} />
                                        <DropDownComponent names={["DRAFT", "OPEN", "REGISTRATIONSOPEN","REGISTRATIONSCLOSED", "HOLD", "COMPLETED","CLOSED"]} custname="EventStatus" custid="txtEventstatus" custplaceholder="Event Status" externalstateValue={eventStatus} onExternalValue={setEventStatus} />

                                    </div>
                                </div>
                            </fieldset>
                            <fieldset className="form-group p-3">
                                <legend className="w-auto px-2 subheading">Additional Fields</legend>
                                <div className="row pt-2">

                                    <div className="col-lg-6 col-md-6 col-sm-6">
                                        <CheckboxComponent custname="parking" custid="txtevttktparking" type="checkbox" custplaceholder="Parking" onExternalValue={setParking} onExternalBind={parking} />

                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-6">
                                        <CheckboxComponent custname="tshirt" custid="txtevttkttshirt" type="checkbox" custplaceholder="T-Shirt" onExternalValue={setTshirt} onExternalBind={tshirt} />

                                    </div>
                                </div>
                            </fieldset>
                            <fieldset className="form-group p-3">
                                <legend className="w-auto px-2 subheading">Event Images</legend>
                                <div className="row pt-2">
                                    <div className="col-lg-6 col-md-6 col-sm-12">
                                        <div className="form-field form-label-group-cust">
                                            <label className="subheading">Background Banner Image (1600x900px, max 500KB)</label>
                                            <div className="form-field form-label-group-cust ">
                                                <input 
                                                    id="fileBackgroundBanner" 
                                                    type="file" 
                                                    className="form-control-cust" 
                                                    name="backgroundBanner" 
                                                    placeholder="Upload Background Banner"
                                                    onChange={handleBackgroundBannerChange}
                                                />
                                                <label htmlFor="fileBackgroundBanner">Upload Background Banner</label>
                                            </div>
                                            {backgroundBannerUrl && (
                                                <div className="mt-2">
                                                    <img src={backgroundBannerUrl} alt="Background Banner Preview" style={{ width: '200px', height: 'auto', objectFit: 'cover', border: '1px solid #ccc' }} />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-12">
                                        <div className="form-field form-label-group-cust">
                                            <label className="subheading">I Am Attending Image (1600x900px, max 300KB)</label>
                                            <div className="form-field form-label-group-cust ">
                                                <input 
                                                    id="fileIamAttending" 
                                                    type="file" 
                                                    className="form-control-cust" 
                                                    name="iamAttending" 
                                                    placeholder="Upload I Am Attending Image"
                                                    onChange={handleIamAttendingChange}
                                                />
                                                <label htmlFor="fileIamAttending">Upload I Am Attending Image</label>
                                            </div>
                                            {iamAttendingUrl && (
                                                <div className="mt-2">
                                                    <img src={iamAttendingUrl} alt="I Am Attending Preview" style={{ width: '200px', height: 'auto', objectFit: 'cover', border: '1px solid #ccc' }} />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </fieldset>
                            <fieldset className="form-group p-3">
                                <legend className="w-auto px-2 subheading">Ticket Type Details</legend>
                                <div className="row pt-2">

                                    <div className="col-lg-6 col-md-6 col-sm-6">
                                        <InputComponent custname="eventtickettype" custid="txtevttkttype" custplaceholder="Ticket Type Name" onExternalValue={setTicketType} onExternalBind={ticketType} />
                                        <InputComponent custname="eventprice" custid="txtevttktprice" custplaceholder="Ticket Price" onExternalValue={setEventprice} onExternalBind={eventprice} />
                                        <InputComponent custname="eventinitialprice" custid="txtevttktinitialprice" custplaceholder="Ticket Initial Price" onExternalValue={setEventInitialprice} onExternalBind={eventInitialprice} />
                                        <DropDownComponent names={["ALL", "Male", "Female", "Other"]} custname="EventValidateGender" custid="txtEventValidateGender" custplaceholder="Validate Gender" externalstateValue={eventValidateGender} onExternalValue={setEventValidateGender} />
                                       


                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-6">
                                    <DropDownComponent names={["ACTIVE", "CLOSED"]} custname="EventTktStatus" custid="txtEventTktstatus" custplaceholder="Ticket Status" externalstateValue={eventTktStatus} onExternalValue={setEventTktStatus} />

                                        <DropDownComponent names={["YES", "NO"]} custname="EventValidateMembership" custid="txtEventValidateMembership" custplaceholder="Validate Membership" externalstateValue={eventValidateMembership} onExternalValue={setEventValidateMembership} />
                                        <DropDownComponent names={["YES", "NO"]} custname="AllowBulkBooking" custid="txtAllowBulkBooking" custplaceholder="AllowBulkBooking" externalstateValue={allowBulkBooking} onExternalValue={setAllowBulkBooking} />
                                       
                                        <TextAreaComponent custname="TicketContent" custid="txttktcontent" custplaceholder="TktContent" onExternalValue={setTicketTypeContent} onExternalBind={ticketTypeContent} />
                                        <InputComponent custname="priority" custid="txtevttktpriority" custplaceholder="Priority" onExternalValue={setPriority} onExternalBind={priority} />
                                        <InputComponent custname="customdate" custid="txtevttktcustomdate" custplaceholder="Custom Date" onExternalValue={setCustomdate} onExternalBind={customdate} />

                                    </div>
                                </div>
                                <fieldset className="form-group p-3">
                                <legend className="w-auto px-2 subheading">Bulk Discount</legend>
<div  className="row p-1 ">
<div className="col-lg-3 col-md-3 col-sm-3">
<InputComponent custname="discountfrom" custid="txtevttktdiscountfrom" custplaceholder="From"  type="number" onExternalValue={setDiscountFrom} onExternalBind={discountfrom} />
</div>     
<div className="col-lg-3 col-md-3 col-sm-3">
<InputComponent custname="discountto" custid="txtevttktdiscountto" custplaceholder="To"  type="number" onExternalValue={setDiscountTo} onExternalBind={discountTo} />
</div>   
<div className="col-lg-3 col-md-3 col-sm-3">
<InputComponent custname="discountpecentage" custid="txtevttktdiscountpecentage" type="number" custplaceholder="Discount Percentage" onExternalValue={setDiscountPercentage} onExternalBind={discountPercentage} />
</div>  
<div className="col-lg-3 col-md-3 col-sm-3">
<div className="form-field text-center button-fa" >
<a href="#" onClick={(e) => onDiscountSaveClick(e)} className="button-fa" > <i className="fa  fa-save"></i> </a>&nbsp;&nbsp;&nbsp;
<a href="#" onClick={(e) => onDiscountCancel(e)}  className="button-fa"> <i className="fa  fa-window-close"></i> </a>
     </div>
</div>                    
</div>
<div  className="row p-1 ">
<div className="col-lg-12 col-md-12 col-sm-12">
<DataTable
                                            columns={discountTableColumns}
                                            data={discountTableData}
                                        />
    </div>
</div>
</fieldset>
                                <div className="row pt-2">

                                    <div className="col-lg-6 col-md-6 col-sm-6">
                                        <div className="form-field text-center" >
                                            <button type="submit" className="btn-default" onClick={(e) => onNewTicketClick(e)} >SAVE TICKET TYPE  <i className="fa fa-arrow-circle-right"></i></button>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-6">

                                        <div className="form-field text-center" >
                                            <button type="submit" className="btn-default" onClick={(e) => onCancelNewTicketType(e)} >CANCEL  <i className="fa fa-arrow-circle-right"></i></button>
                                        </div>
                                    </div>
                                </div>
                            </fieldset>
                            <fieldset className="form-group p-3">
                                <legend className="w-auto px-2 subheading">Ticket Types</legend>
                                <div className="row pt-2">

                                    <div className="col-lg-12 col-md-12 col-sm-12">

                                        <DataTable
                                            columns={columns}
                                            data={eventTicketTypesList}
                                        />
                                    </div>
                                </div>
                            </fieldset>
                            <div className="row">
                                <div className="col-lg-6 col-md-6 col-sm-6">
                                    <div className="form-field text-center" >
                                        <button type="submit" disabled={submitLoading} className="btn-default" onClick={(e) => onClickAddEvent(e)} >SAVE  {submitLoading ? <i className="fa fa-circle-o-notch fa-spin"></i> : <i className="fa fa-arrow-circle-right"></i>}</button>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-6">
                                    <div className="form-field text-center " >
                                        <button type="submit" disabled={submitLoading} className="btn-default" onClick={(e) => onClickResetEvent(e)} >RESET  {submitLoading ? <i className="fa fa-circle-o-notch fa-spin"></i> : <i className="fa fa-arrow-circle-right"></i>}</button>
                                    </div>
                                </div>
                            </div>
                        </form>


                    </div> {/* <!--register-sec-details end--> */}
                </div>

            </section> }
        </>
    );
};




export { AddEvent };